import React, { Component } from 'react';
import ForwardCoaching from './components/ForwardCoaching/ForwardCoaching';
import EditableText from './../../../../components/EditableText/EditableText';
import ExpandText from './../ExpandText/ExpandText';
import classNames from 'classnames';
import style from './style/reflection.scss';

export default class Reflection extends Component {
    render() {
        const {
            submitReflectionText,
            reflectionText,
            textareaPlaceholderText,
            textareaPlaceholderTextActive,
            introductionText,
            forwardCoaching,
            forWardCoachingTitle,
            forWardCoachingText,
            forWardCoachingLinkText,
            forWardCoachingLink,
            isFinalized,
            textEditable,
            allowedToEditReflection,
            saveInterval,
            templateSlug = null,
            slug = null,
            handle,
            expanded,
            resizeSection,
            index,
            classes
        } = this.props;

        return (<div
            role="button"
            tabIndex="-1"
            className={ classNames(style.reflection_content_wrapper, classes?.root) }
        >
            { introductionText ? <ExpandText
                text={ introductionText }
                classes={{
                    root: style.expandText__reflection
                }}
                resize={ resizeSection ? event => resizeSection(event, index, handle) : null }
                index={ index || null }
                handle={ handle || null }
                expanded={ expanded || false }
            /> : null }

            <div className={classNames(style.scrollableArea, classes?.scrollableArea)}>
                <EditableText
                    saveReportText={ submitReflectionText }
                    isFinalized={ isFinalized }
                    textEditable={ textEditable }
                    templateSlug={ templateSlug }
                    slug={ slug }
                    name={ 'reflection' }
                    text={ reflectionText }
                    textareaPlaceholderText={ textareaPlaceholderText }
                    textareaPlaceholderTextActive={ textareaPlaceholderTextActive }
                    allowedToEditReflection={ allowedToEditReflection }
                    saveInterval={ saveInterval }
                />
            </div>
            { forwardCoaching ? <ForwardCoaching
                title={ forWardCoachingTitle }
                text={ forWardCoachingText }
                linkText={ forWardCoachingLinkText }
                link={ forWardCoachingLink }
            /> : null }
        </div>);
    }
}
